/**
 * Services
 */
import { isOnPage, loadPost } from './utils';

if (isOnPage('.services__item-link')) {
  const serviceEndpoint = `${window.location.origin}/wp-json/motion/v1/service/`;

  Array.from(document.querySelectorAll('.services__item-link')).forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      loadPost(btn, serviceEndpoint);
    });
  });
}
